import { GlobalReducer } from "@core/store/reducers/global.reducer";

export default {
  global: GlobalReducer,
};
